import { REMOVE_DOMAIN_SUCCESS } from "../actions/domains";
import {remove} from "./common";

export default function paginate(state = { pages: [], items: {}, currentPage: 0 }, action) {

  if (action.limit) {
    state.limit = action.limit;
  }

  if (action.items) {
    state.items = action.items.reduce((state, item) => ({
      ...state,
      [item.id]: item
    }), state.items);
  }

  if (action.type === REMOVE_DOMAIN_SUCCESS) {
    state.items = remove(state.items,item => {
          return item.id === action.domainInvitationId
        }
      );
  }

  // FIXME: wtf
  if (action.token || action.hasOwnProperty("nextPageToken")) {
    const prevPage = action.token ? state.pages.find(p => p.nextPageToken === action.token) : null;
    const currentPage = prevPage ? prevPage.n + 1 : 0;

    state.pages[currentPage] = {
      ...state.pages[currentPage],
      n: currentPage,
      token: action.token,
      ids: (action.items || []).map(i => i.id),
      nextPageToken: action.nextPageToken
    };

    state.pages[currentPage + 1] = {
      ...state.pages[currentPage + 1],
      token: action.nextPageToken,
      n: currentPage + 1,
      ids: []
    };

    state.currentPage = currentPage;
    state.currentToken = action.token;
  }

  if (action.totalCount !== undefined) {
    state.totalCount = action.totalCount;
  }

  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/paginate.js